import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.page.html',
  styleUrls: []
})
export class PaymentPage implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
